export default {
  ZH_HK: {
    edit: "編輯",
    delete: "刪除",
    copy: "複製",
    download: "下載",
    requestError: "請求失敗",
    use: "使用",
    related: "關聯課程",
    create: "創建活動",
    downLoadWord: "下載Word",
    openWord: "打開Word",
    ActivityList: "活動列表",
    disassociation: "解除關聯",
    open: "進入",
    useTips: "點擊使用按鈕會將內容加入我的教案"
  },
  zh_cn: {
    edit: "编辑",
    delete: "删除",
    copy: "复制",
    download: "下载",
    requestError: "请求失败",
    use: "使用",
    related: "关联课程",
    create: "创建活动",
    downLoadWord: "下载Word",
    openWord: "打开Word",
    ActivityList: "活动列表",
    disassociation: "解除关联",
    open: "进入",
    useTips: "点击使用按钮会将内容加入我的教案"
  },

  EN: {
    edit: "Edit",
    delete: "Delete",
    copy: "Copy",
    requestError: "Request Error",
    download: "Download",
    use: "Make a copy",
    related: "Related courses",
    create: "Create Activity",
    downLoadWord: "Download Word",
    openWord: "Open Word",
    ActivityList: "Activity List",
    disassociation: "Disassociation",
    open: "go in",
    useTips: "Clicking the 'Make a copy' button will add the content to my lesson plan"
  },

  es: {
    edit: "Editar",
    delete: "Eliminar",
    copy: "Copiar",
    download: "Descargar",
    requestError: "Error de Solicitud",
    use: "Uso",
    related: "Cursos relacionados",
    create: "Crear una actividad",
    downLoadWord: "Descargar Palabra",
    openWord: "Abrir Palabra",
    ActivityList: "Lista de Actividades",
    disassociation: "Desconexión",
    open: "Entrar",
    useTips: "Hacer clic en el botón 'Uso' añadirá el contenido a mi plan de clase"
  }
};
